import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    description: {
      label: {
        id: 'properties.description',
        defaultMessage: 'Description',
        description: 'label of the form field description',
      },
    },
    amount: {
      label: {
        id: 'properties.amount',
        defaultMessage: 'Amount',
        description: 'label of the form field amount',
      },
    },
    percentage: {
      label: {
        id: 'properties.percentage',
        defaultMessage: 'Percentage',
        description: 'label of the form field percentage',
      },
    },
  },
};

export default defineMessages(translations);
